<template>
    <div>
        <myHead/>
        <a-spin :spinning="isLoading" tip="加载中...">
        <div>
            <a-result v-if="!task.IsPay" class="animate__animated" >
                <template #icon>
                    <svg style="vertical-align:middle" width="50" height="50" t="1626154488750" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4923"><path d="M256 960H64V448h192v512z m-128-64h64V512h-64v384z" p-id="4924" fill="#ea4c89"></path><path d="M574.22 960H224c-17.67 0-32-14.33-32-32s14.33-32 32-32h340.6l317.87-259.34C863.6 618.91 844.87 608 832 608c-39.28 0-134.13 44.66-210.35 80.54-21.17 9.97-43.06 20.27-63.55 29.58-27.35 12.42-57.47 16.46-87.11 11.67l-156.1-25.2c-17.45-2.82-29.31-19.24-26.49-36.69 2.82-17.45 19.25-29.31 36.69-26.49l156.1 25.2c17.16 2.77 34.6 0.43 50.44-6.76 20.09-9.12 40.81-18.88 62.75-29.21C689.02 586.08 778.41 544 832 544c25.99 0 53.41 11.72 81.52 34.84 17.11 14.08 30.64 29.15 38.98 39.32 5.77 7.04 8.45 15.91 7.53 24.96-0.92 9.06-5.31 17.21-12.38 22.96L597.61 951.66c-6.56 5.37-14.88 8.34-23.39 8.34z m-17.05-57.94c-0.02 0.01-0.03 0.03-0.05 0.04l0.05-0.04z m350.06-285.6c-0.02 0.02-0.04 0.03-0.06 0.05l0.06-0.05z" p-id="4925" fill="#ea4c89"></path><path d="M625.69 668.62L312.45 512H224v-64h103.55l326.76 163.38zM546.44 501.19v-48.44h-57.81c-12.5 0-18.75-5.71-18.75-17.19 1.03-9.38 7.28-15.09 18.75-17.19h57.81v-26.56h-57.81c-12.5 0-18.75-5.71-18.75-17.19 1.03-9.38 7.28-15.09 18.75-17.19h32.81l-50-70.31c-5.22-4.15-7.3-9.89-6.25-17.19 1.03-17.7 10.94-27.59 29.69-29.69 9.38 1.05 17.19 5.22 23.44 12.5l57.81 82.81 57.81-82.81c5.2-7.28 13.01-11.45 23.44-12.5 17.7 2.1 27.59 11.99 29.69 29.69 0 7.3-2.1 13.04-6.25 17.19l-50 70.31h32.81c10.4 2.1 16.65 7.81 18.75 17.19-1.05 11.47-7.3 17.19-18.75 17.19h-57.81v26.56h57.81c10.4 2.1 16.65 7.81 18.75 17.19-1.05 11.47-7.3 17.19-18.75 17.19h-57.81v48.44c-1.05 17.72-10.94 26.56-29.69 26.56-19.8 0-29.69-8.84-29.69-26.56z" p-id="4926" fill="#ea4c89"></path><path d="M832 384c0 76.39-33.64 145.06-86.87 192h86.92C873.54 520.91 896 454.18 896 384c0-85.48-33.29-165.83-93.73-226.27S661.48 64 576 64s-165.83 33.29-226.27 93.73S256 298.52 256 384c0 21.75 2.17 43.16 6.37 64h65.73c-5.29-20.46-8.1-41.91-8.1-64 0-141.16 114.84-256 256-256s256 114.84 256 256z" p-id="4927" fill="#ea4c89"></path></svg>
                    <!-- <svg   t="1626154488750" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4923"><path d="M256 960H64V448h192v512z m-128-64h64V512h-64v384z" p-id="4924"></path><path d="M574.22 960H224c-17.67 0-32-14.33-32-32s14.33-32 32-32h340.6l317.87-259.34C863.6 618.91 844.87 608 832 608c-39.28 0-134.13 44.66-210.35 80.54-21.17 9.97-43.06 20.27-63.55 29.58-27.35 12.42-57.47 16.46-87.11 11.67l-156.1-25.2c-17.45-2.82-29.31-19.24-26.49-36.69 2.82-17.45 19.25-29.31 36.69-26.49l156.1 25.2c17.16 2.77 34.6 0.43 50.44-6.76 20.09-9.12 40.81-18.88 62.75-29.21C689.02 586.08 778.41 544 832 544c25.99 0 53.41 11.72 81.52 34.84 17.11 14.08 30.64 29.15 38.98 39.32 5.77 7.04 8.45 15.91 7.53 24.96-0.92 9.06-5.31 17.21-12.38 22.96L597.61 951.66c-6.56 5.37-14.88 8.34-23.39 8.34z m-17.05-57.94c-0.02 0.01-0.03 0.03-0.05 0.04l0.05-0.04z m350.06-285.6c-0.02 0.02-0.04 0.03-0.06 0.05l0.06-0.05z" p-id="4925"></path><path d="M625.69 668.62L312.45 512H224v-64h103.55l326.76 163.38zM546.44 501.19v-48.44h-57.81c-12.5 0-18.75-5.71-18.75-17.19 1.03-9.38 7.28-15.09 18.75-17.19h57.81v-26.56h-57.81c-12.5 0-18.75-5.71-18.75-17.19 1.03-9.38 7.28-15.09 18.75-17.19h32.81l-50-70.31c-5.22-4.15-7.3-9.89-6.25-17.19 1.03-17.7 10.94-27.59 29.69-29.69 9.38 1.05 17.19 5.22 23.44 12.5l57.81 82.81 57.81-82.81c5.2-7.28 13.01-11.45 23.44-12.5 17.7 2.1 27.59 11.99 29.69 29.69 0 7.3-2.1 13.04-6.25 17.19l-50 70.31h32.81c10.4 2.1 16.65 7.81 18.75 17.19-1.05 11.47-7.3 17.19-18.75 17.19h-57.81v26.56h57.81c10.4 2.1 16.65 7.81 18.75 17.19-1.05 11.47-7.3 17.19-18.75 17.19h-57.81v48.44c-1.05 17.72-10.94 26.56-29.69 26.56-19.8 0-29.69-8.84-29.69-26.56z" p-id="4926"></path><path d="M832 384c0 76.39-33.64 145.06-86.87 192h86.92C873.54 520.91 896 454.18 896 384c0-85.48-33.29-165.83-93.73-226.27S661.48 64 576 64s-165.83 33.29-226.27 93.73S256 298.52 256 384c0 21.75 2.17 43.16 6.37 64h65.73c-5.29-20.46-8.1-41.91-8.1-64 0-141.16 114.84-256 256-256s256 114.84 256 256z" p-id="4927"></path></svg> -->
                    <span style="font-size:30px;letter-spacing:5px;margin-left:10px;vertical-align:middle;color:#ea4c89">收银台</span>
                </template>
                <template #title>
                    <span style="letter-spacing:2px">{{task.Code}}</span>
                </template>
                <template #subTitle>
                    <div style="color:rgba(0, 0, 0, 0.85);margin-top:14px;letter-spacing:2px">
                        <p>商品本金：<span style="font-weight:500">{{task.Price}}</span> 元</p>
                        <p>服务佣金：<span style="font-weight:500">{{task.Commission}}</span> 元</p>
                        
                        <p>需要支付：<span style="font-weight:500">{{task.Price+task.Commission-task.Payout}}</span> 元</p>
                        <p>
                            <a-checkbox :disabled="!canPayout" @change="payoutChange" v-model:checked="usePayout">使用赔付账户(余额<span style="font-weight:500">{{task.MemberPayout}}</span>元)支付 <span style="font-weight:500">{{task.Payout}}</span> 元佣金</a-checkbox>
                             
                        </p>
                        <p>
                            <b v-if="task.MemberBalance>=0">您当前现金余额为 {{task.MemberBalance}} 元，最大可以透支 {{task.MemberAdvance}} 元</b>
                            <b v-else>您当前现金余额为 {{task.MemberBalance}} 元，还可以透支 {{task.MemberAdvance+task.MemberBalance}} 元</b>
                        </p>
                    </div>
                    
                </template>

                <template #extra>
                    <a-row :gutter="40">
                        <a-col :span="12">
                            <router-link target="_blank" :to="{path:'/myPurse', query:{topUpVisible:true}}">
                                <a-button   class="otherBtn" style="width:200px;float:right;">
                                    去充值
                                </a-button>
                            </router-link>
                        </a-col>
                        <a-col :span="12">
                            <a-button   style="width:200px;float:left"  @click="pay"  class="loginBtn">
                                    付款
                            </a-button>
                        </a-col>
                    </a-row>
                    
                    
                </template>
            </a-result>

            <a-result v-else status="success" class="animate__animated animate__bounceInDown">
                <template #title>
                    <span style="letter-spacing:2px">发布成功</span>
                </template>
                <template #subTitle>
                    <span style="letter-spacing:1px">请稍等片刻，我们需要审核您发布的任务信息是否正确！</span>
                </template>

                <template #extra>
                    <router-link  :to="{path:'/pushTask'}">
                        <a-button>再来一发</a-button>
                    </router-link>
                </template>
                <div class="desc">
                <p style="font-size: 16px;letter-spacing:2px">
                    <strong>感谢您的信任，我们一直在致力于提供更好的服务：</strong>
                </p>
                <!-- <p style="letter-spacing:1px;">
                    <FireOutlined />
                    <span> 查看您今天计划执行进度</span>
                    <router-link :to="{path:'/console'}">
                        <a style="color:#f082ac"> 去看看&gt;</a>
                    </router-link>
                </p> -->
                </div>
            </a-result>
        </div>
        </a-spin>
        <myFooter/>
    </div>
</template>
<script>
// import { FireOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
 
 
import myHead from '../components/myHead'
import myFooter from '../components/myFooter'
//  import myPreview from '../components/myPreview'

import { taskGetTask,pay } from '@/request.js'


export default {
    
    components:{ myHead , myFooter  },
    data() {
        return {
            isLoading:false,
            usePayout:true,
            task:{},
            canPayout:true,
        };
    },
    methods: {

        pay(){
            this.isLoading=true;
            pay({taskCode:this.task.Code,isUsePayout:this.usePayout},(res)=>{
                if(res.IsSuccess){
                    this.task.IsPay=true;
                }else{
                    message.error(res.Message); 
                }
                this.isLoading=false;
            });
        },
        payoutChange(){
            if(this.usePayout){
                this.task.Payout= this.task.MemberPayout >= this.task.Commission ? this.task.Commission : this.task.MemberPayout;
            }else{
                this.task.Payout=0;
            }
        },
    },
    created(){
    },
    mounted() {
        this.isLoading=true;
        taskGetTask({
            code:this.$route.query.code
        },(res)=>{
            this.task=res.Result;
            if(this.task.IsDitui){
                this.canPayout=false;
                this.usePayout=false;
            }
            this.isLoading=false;
        });
    }
};
</script>
<style scoped>

.queryDiv{
    margin-top:20px;
    margin-bottom:20px;
    margin-right:20px;
    margin-left:20px
}
.queryTxt{
    font-family: "Haas Grot Text R Web", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #0d0c22;
}
</style>